"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBreakpointIndex = exports.E_CATALOGUE_BREAKPOINT = void 0;
var _mui = require("@ori-ui/mui");
/**
 * The breakpoint where eCatalogue / iPaper layout
 * logic changes from mobile to desktop.
 */
const E_CATALOGUE_BREAKPOINT = exports.E_CATALOGUE_BREAKPOINT = 1024;

/**
 * @returns Zero-based breakpoint index as one of the following:
 * 0 - Small screen for pages other than eCatalogue / iPaper
 *     Based on the 'sm' theme size. Minibag is not displayed
 *     in this case outside of eCatalogue, and is displayed as a popup
 *     in eCatalogue.
 * 1 - Middle breakpoint. Minibag is displayed in a popup for all pages.
 *     Size is based on the E_CATALOGUE_BREAKPOINT constant.
 * 2 - Large breakpoint. Minibag is displayed as popup outside of eCatalogue,
 *     and in fixed position appearing as page content in eCatalogue
 *     ("desktop" mode). Size is based on the E_CATALOGUE_BREAKPOINT constant.
 */
const useBreakpointIndex = () => {
  const theme = (0, _mui.useTheme)();
  const isSmallScreen = (0, _mui.useMediaQuery)(theme.breakpoints.down('sm'), {
    noSsr: true
  });
  const isMiddleScreen = (0, _mui.useMediaQuery)(theme.breakpoints.down(E_CATALOGUE_BREAKPOINT), {
    noSsr: true
  });
  let breakpointIndex = 0;
  if (isSmallScreen) {
    breakpointIndex = 0;
  } else if (isMiddleScreen) {
    breakpointIndex = 1;
  } else {
    breakpointIndex = 2;
  }
  return breakpointIndex;
};
exports.useBreakpointIndex = useBreakpointIndex;
